import { useQuery } from '@tanstack/react-query';
import { apiClientWH } from '@shared/services/ApiClient';
import { ProductLocationsApiAdapter } from '../adapters';

export const useProductLocations = (productIds: number[]) => {
  const productLocationsAdapter = new ProductLocationsApiAdapter(apiClientWH);

  const {
    data: productLocations = [], // ✅ Inicializar con array vacío
    isLoading,
    error,
    refetch,
  } = useQuery({
    queryKey: ['productLocations', productIds],
    queryFn: () => productLocationsAdapter.getProductLocations(productIds),
    enabled: productIds.length > 0,
    staleTime: 5 * 60 * 1000, // 5 minutos
    gcTime: 10 * 60 * 1000, // 10 minutos
  });

  // 🎯 Crear un mapa de product_id -> location_codes (array) para manejar múltiples ubicaciones
  const productLocationMap = Array.isArray(productLocations)
    ? productLocations.reduce(
        (acc, location) => {
          if (!acc[location.product_id]) {
            acc[location.product_id] = [];
          }
          acc[location.product_id].push(location.code);
          return acc;
        },
        {} as Record<number, string[]>
      )
    : {};

  // (Sin logs de depuración)

  return {
    productLocations: productLocations || [],
    productLocationMap,
    isLoading,
    error: error?.message || null,
    refetch,
  };
};
